import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import FileUpload from "@/components/FileUpload";
import { Newspaper, Trash2, Plus, AlertCircle } from "lucide-react";

const CATEGORIES = ["federation", "circular", "press", "national", "international"];

export default function NewsManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", category: "federation", body: "", image_url: "", is_published: true });
  const [err, setErr] = useState("");
  const refresh = () => api.get("/news").then((r) => setItems(r.data));
  useEffect(() => { refresh(); }, []);

  const add = async (e) => {
    e.preventDefault(); setErr("");
    try {
      await api.post("/news", form);
      setForm({ title: "", category: "federation", body: "", image_url: "", is_published: true });
      refresh();
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail) || e2.message); }
  };
  const remove = async (id) => { if (window.confirm("Remove this news item?")) { await api.delete(`/news/${id}`); refresh(); } };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <section className="bg-white border border-slate-200 rounded-md p-5">
      <div className="flex items-center gap-2"><Newspaper className="h-5 w-5 text-nkf-red" /><h2 className="font-display text-xl text-nkf-blue">News & Updates</h2></div>
      <form onSubmit={add} className="mt-4 grid grid-cols-1 md:grid-cols-12 gap-3">
        <input required value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="News headline *" className="md:col-span-9 px-3 py-2.5 border border-slate-300 rounded-md text-sm" />
        <select value={form.category} onChange={(e) => set("category", e.target.value)} className="md:col-span-3 px-3 py-2.5 border border-slate-300 rounded-md text-sm bg-white">
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <textarea required value={form.body} onChange={(e) => set("body", e.target.value)} rows={3} placeholder="News body *" className="md:col-span-12 px-3 py-2.5 border border-slate-300 rounded-md text-sm" />
        <div className="md:col-span-9">
          <FileUpload value={form.image_url} onChange={(v) => set("image_url", v)} label="Cover image (optional)" />
        </div>
        <button className="md:col-span-3 self-end inline-flex items-center justify-center gap-1 bg-nkf-blue hover:bg-nkf-navy text-white text-xs font-bold uppercase tracking-widest px-4 py-2.5 rounded transition"><Plus className="h-3.5 w-3.5" /> Publish</button>
      </form>
      {err && <div className="mt-3 flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 p-2.5 rounded text-sm"><AlertCircle className="h-4 w-4 mt-0.5" /> {err}</div>}
      <div className="mt-4 divide-y divide-slate-100">
        {items.map((n) => (
          <div key={n.id} className="py-2.5 flex items-center justify-between gap-3">
            <div className="min-w-0 flex items-center gap-3">
              {n.image_url && <img src={n.image_url} alt="" className="h-10 w-10 rounded object-cover" />}
              <div className="min-w-0">
                <div className="font-semibold text-nkf-blue truncate text-sm">{n.title}</div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500">{n.category} · {(n.published_at || "").slice(0, 10)}</div>
              </div>
            </div>
            <button onClick={() => remove(n.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {!items.length && <div className="py-6 text-center text-slate-400 text-sm">No news yet.</div>}
      </div>
    </section>
  );
}
